import { Platform, Dark, setCssVar } from "quasar";
import { MutationTree } from "vuex";
import LocalDb from "src/services/db";
import { SettingsStateInterface } from "./state";

const mutation: MutationTree<SettingsStateInterface> = {
  set(
    state: SettingsStateInterface,
    payload: {
      key: keyof SettingsStateInterface;
      value: never;
    }
  ) {
    state[payload.key] = payload.value;
  },

  setSetting(state: SettingsStateInterface, { key, setting }) {
    state.list[key] = setting;
  },

  setSettingFieldValue(
    state: SettingsStateInterface,
    { key, value, field = "value", previousValue = undefined }
  ) {
    if (!previousValue) {
      previousValue = state.list[key][field];
    }

    // console.log("setSettingFieldValue", key, field, value);
    state.list[key][field] = value;

    //#region darkMode
    const setBrandColors = () => {
      const brandColorsValue =
        Dark.isActive && state.list.brandColorsDark?.value
          ? state.list.brandColorsDark?.value
          : state.list.brandColorsLight?.value;
      if (brandColorsValue) {
        for (const colorName of Object.keys(brandColorsValue)) {
          const colorValue = brandColorsValue[colorName];
          setCssVar(colorName, colorValue);
        }
      }
    };
    const setDarkMode = (mode: boolean | "auto") => {
      Dark.set(mode);
      setBrandColors();
    };
    //#endregion
    if (key == "autoDarkMode") {
      // console.log("autoDarkMode", value);
      setDarkMode(value ? "auto" : state.list["darkMode"]?.value);
    } else if (key == "darkMode") {
      // console.log("darkMode", value);
      setDarkMode(state.list["autoDarkMode"]?.value ? "auto" : value);
    } else if (key == "brandColorsLight" || key == "brandColorsDark") {
      if (value) {
        setBrandColors();
      }
    } else if (key == "menuItems") {
      const __pageMap: any = {};
      const map = (items: any[]) => {
        if (!items) return;
        for (const item of items) {
          if (item.link) {
            __pageMap[item.link] = item;
          }
          map(item.children);
        }
      };
      map(value);
      state.list["__pageMap"]["value"] = __pageMap;
    } else if (key == "meta_theme") {
      if (previousValue?.theme)
        document.body.classList?.remove(previousValue.theme);
      if (previousValue?.themeW)
        document.body.classList?.remove(previousValue.themeW);
      if (value?.theme) document.body.classList?.add(value.theme);
      if (value?.themeW) document.body.classList?.add(value.themeW);
    } else if (key == "sampleRate" || key == "currentSampleRate") {
      if (Platform.is.safari || Platform.is.edge) {
        state.list[key].value = 48000;
      }
    }
  },

  saveToStorage(state: SettingsStateInterface, { key, value }) {
    // console.log("==============");
    // console.log("saveToStorage key", key);
    // console.log("saveToStorage value", value);
    // console.log("saveToStorage defaultValue", state.list[key].defaultValue);
    // console.log("==============");

    // TODO: сравнивать объекты по нормальному, по значению
    const isOverride =
      typeof value == "object"
        ? JSON.stringify(value) != JSON.stringify(state.list[key].defaultValue)
        : value != state.list[key].defaultValue;
    if (isOverride) {
      LocalDb.then((db) => db.settings.setSetting(key, value));
    } else {
      LocalDb.then((db) => db.settings.deleteSetting(key));
    }
  },

  setCurrentPage(state: SettingsStateInterface, value) {
    state.currentPage = value;
  },
};

export default mutation;
